<div class="wrapper">
  <div class="mb-4 t-6@r font-weight-500">{{ bids.length }} Top Admirers</div>
  @for (bid of bids; track bid.id) {
    <a class="entry display-flex align-items-center pv-2@r" [routerLink]="['/next/profile', bid.benefactor_browse_id]">
      <div class="entry__icon-wrapper t-4@r center-flex mr-1@r">
        @if ($index + 1 <= distinguishedBidsCount) {
          <sb-top-admirer-badge [place]="$index + 1" />
        } @else {
          <div class="t-9@r font-weight-500 color-ash">
            {{ $index + 1 }}
          </div>
        }
      </div>
      <sb-profile-photo [photoUrl]="bid.image_url" [size]="'sm'" />
      <div class="t-9@r ml-1@r font-weight-500" [ngClass]="$first ? 'color-black' : 'color-ash'">
        {{ bid.full_name }}
      </div>
      <i class="nc-icon nc-arrow-right color-iron ml-auto i-9@r"></i>
    </a>
    @if (!$last) {
      <hr class="bg-cloud border-radius-pill opacity-30 height-2" />
    }
  }
</div>
